import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { TransformDetail } from 'src/api/models';
import { Widget, Dashboard } from 'src/api/models'
import { IWidgetEditor, WidgetType, ChartWidget, TimeSeriesDetail } from "src/app/models/dashboard";
import { StorageTablesService } from "src/service/storage-tables.service";
import { ApplicationConfigService } from "src/service/application-config.service";

@Component({
  selector: "app-size-comparison-widget-editor",
  templateUrl: "./size-comparison-widget-editor.component.html",
  styleUrls: ["./size-comparison-widget-editor.component.css"],
})
export class SizeComparisonWidgetEditorComponent implements OnInit, IWidgetEditor  {
  // @ViewChildren(ImageOverlayComponent) imgOverlayList: QueryList<ImageOverlayComponent>

  public widgetType: WidgetType;
  public widget: ChartWidget;
  public dashboard: Dashboard;
  public w: any;
  selectedZoneColor: any;
  selectedZoneNumber: any;

  public transformList: TransformDetail[];
  private colours: string[];

  constructor(public storageTablesService: StorageTablesService, public app: ApplicationConfigService) {
    this.colours = app.colours;
  }


  ngOnInit() {

    this.w = <any>this.widget;
    

    console.log('latest simple widget editor loaded');
    //this.active = {uri:null} as TimeSeriesDetail;
    if (!this.w.timeSeriesDetailList || this.w.timeSeriesDetailList.length == 0){
      this.w.timeSeriesDetailList = [
        new TimeSeriesDetail()
      ];
    }
    if (this.w.timeSeriesDetailList[0].transforms == null){
      this.w.timeSeriesDetailList[0].transforms = [];
    }
  }
 

  public addItem() {
    this.w.timeSeriesDetailList.push({
      uri: null,
      name: null,
      valueSuffix: "",
      colour: this.colours[this.w.timeSeriesDetailList.length],
      transforms: []
    });
  }

  private findPreviousColour(ts):string{
    let returnColour = this.colours[0];
    const index = ts.zoneColours.length -1;
    //if return default colour when the zoneColors has not existing item.
    if(index == -1) return returnColour;
    try { 
      returnColour = ts.zoneColours[index].colour;
      }catch (err){
      console.error(err);
      return returnColour;
    }
    return returnColour;
  }


  public removeTimeSeries(timeSeries: any): void {
    var index = this.w.timeSeriesDetailList.indexOf(timeSeries);
    if (index > -1) {
      this.w.timeSeriesDetailList.splice(index, 1);
    }
  }
}
